/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RefundedbagQueryResult model module.
 * @module model/RefundedbagQueryResult
 * @version 1.0
 */
class RefundedbagQueryResult {
    /**
     * Constructs a new <code>RefundedbagQueryResult</code>.
     * @alias module:model/RefundedbagQueryResult
     */
    constructor() { 
        
        RefundedbagQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefundedbagQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefundedbagQueryResult} obj Optional instance to populate.
     * @return {module:model/RefundedbagQueryResult} The populated <code>RefundedbagQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefundedbagQueryResult();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
RefundedbagQueryResult.prototype['bagType'] = undefined;

/**
 * @member {String} createdAt
 */
RefundedbagQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} date
 */
RefundedbagQueryResult.prototype['date'] = undefined;

/**
 * @member {String} deletedAt
 */
RefundedbagQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
RefundedbagQueryResult.prototype['id'] = undefined;

/**
 * @member {Number} quantity
 */
RefundedbagQueryResult.prototype['quantity'] = undefined;

/**
 * @member {String} updatedAt
 */
RefundedbagQueryResult.prototype['updatedAt'] = undefined;

/**
 * @member {Number} userId
 */
RefundedbagQueryResult.prototype['userId'] = undefined;






export default RefundedbagQueryResult;

